import { z } from "zod";

const metadataTypeSchema = z.enum(['string', 'textArea', 'boolean', 'number', 'date', 'email', 'url', 'image', 'color', 'select_categories_library'] as const);

export const productMetadataSchema = z.object({
  key: z.string().min(1, "Chave é obrigatória"),
  value: z.string().min(1, "Rótulo é obrigatório"),
  type: metadataTypeSchema,
  obrigatorio: z.boolean(),
  default_value: z.boolean().optional().default(false),
});

export const productSchema = () =>
  z.object({
    name: z.string().min(1, "Nome é obrigatório"),
    is_bookstore: z.boolean(),
    is_superapp: z.boolean(),
    create_landing: z.boolean(),
    active: z.boolean().optional().default(false),
    metadata: z.record(z.string(), productMetadataSchema).default({}),
  });

export type ProductFormValues = z.infer<ReturnType<typeof productSchema>>;
